import { createContext } from "react";

import type usePatientIdentityById from "src/hooks/data/load/usePatientIdentityById";

/**
 * Describes the patient identity loader state and its refresh/cache actions.
 */
export interface IPatientIdentityContext extends ReturnType<typeof usePatientIdentityById> {}

/**
 * Shares patient identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const PatientIdentityContext = createContext<IPatientIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default PatientIdentityContext;
